import styled from '@emotion/styled';
import { breakpoint, colors, spacing, typography } from 'component-library';

export const DetailsWrapper = styled.div<{ colCount?: number; largeGap?: boolean }>`
  display: grid;
  grid-template-columns: repeat(${({ colCount }) => colCount}, 1fr);
  gap: ${({ largeGap }) => (largeGap ? spacing.mediumLow : spacing.small)};

  @media (max-width: ${breakpoint.large}px) {
    grid-template-columns: 1fr;
    gap: ${spacing.xsmall};
  }
`;

export const KeyValuePairWrapper = styled.div``;
export const Row = styled.div<{ marginBottom?: string }>`
  display: flex;
  gap: ${spacing.small};
  flex-wrap: wrap;
  margin-bottom: ${({ marginBottom }) => marginBottom ?? '0'};

  > * {
    flex: 1 1 calc(50% - ${spacing.small});
  }
`;

export const ConfirmationContainerWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing.xsmall};
  padding: 0 ${spacing.small};

  @media (max-width: ${breakpoint.medium}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ConfirmationContainerItem = styled.div`
  flex: 1 1 calc(25% - ${spacing.xsmall});
  display: flex;
  flex-direction: row;
  gap: ${spacing.mediumLow};
  align-items: center;

  @media (max-width: ${breakpoint.xlarge}px) {
    flex: 1 1 calc(50% - ${spacing.xsmall});
  }

  @media (max-width: ${breakpoint.medium}px) {
    flex: 1 1 100%;
    gap: ${spacing.xsmall};
  }
`;

export const ValueWrapper = styled.div`
  color: ${colors.base.black};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const SecondaryLabelWrapper = styled.div`
  margin-left: ${spacing.tiny};
  ${typography.other.inputLabel}
`;
